RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmailReset = Marionette.ItemView.extend({
        template: '#notificationEmailResetTemplate',
        ui: {
            modal: '.modal',
            clearAll: '.clear-all',
            alertEmailEnabledDefault: '.alert-email-enabled-default'
        },
        events: {
            'click @ui.clearAll': 'onClickClearAllLandscapeAlerts',
            'change @ui.alertEmailEnabledDefault': 'onChangeAlertEmailEnabledDefault'
        },
        updateAllLandscapes: function (getValueFn) {
            const me = this;

            const landscapeId = RivalIQ.state.landscape.id;
            const landscapeIds = _.map(RivalIQ.state.user.get('landscapes'), 'id');
            const landscapes = _.clone(_.get(RivalIQ.settings.userSettings, 'landscapes', {}));
            const emailEnabledDefault = RivalIQ.state.user.get('email_enabled_default');

            _.forEach(landscapeIds, function (id) {
                const settings = {};

                _.each(RivalIQ.enums.email.type, function (typeId) {
                    settings[typeId] = getValueFn(typeId, _.get(landscapes, [id, 'email', 'enabled']), emailEnabledDefault);
                });

                _.set(landscapes, [id, 'email', 'enabled'], settings);
            });

            const emailSettings = _.get(landscapes, [landscapeId, 'email', 'enabled']);

            return RivalIQ.state.user.patchSettings({
                landscapes: landscapes
            }).fail(function () {
                RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
            }).done(function () {
                RivalIQ.state.user.set({
                    emailSettings: emailSettings
                }, {
                    silent: true
                });
                me.triggerMethod('reset:landscapes');
            });
        },
        onClickClearAllLandscapeAlerts: function (e) {
            const me = this;
            e.preventDefault();

            // TODO: should we warn/confirm before doing this?

            me.updateAllLandscapes(_.constant(false));
        },
        onChangeAlertEmailEnabledDefault: function (e) {
            e.preventDefault();
            const me = this;
            const isChecked = me.ui.alertEmailEnabledDefault.is(':checked');
            const defaultSettings = RivalIQ.state.user.getEmailDefaults();

            me.updateAllLandscapes(function (typeId, existingSetting) {
                return _.get(existingSetting, [typeId], defaultSettings[typeId]);
            }).done(function () {
                // NOTE: we don't want to set to true since that would force all unset alert mails
                // on for the user instead of using the values in enums.email.defaultSettings
                RivalIQ.state.user.set('email_enabled_default', (isChecked ? null : false));
            });

        }
    });

    views.Settings = RivalIQ.views.CompositeView.extend({
        events: {
            'click .x-landscape-email-notificaion-all': 'manageAllAlerts'
        },
        getChildView: function (child) {
            return (child.get('isSection') ? views.SettingSection : views.Setting);
        },
        childViewContainer: '.settings-sections',
        template: '#notificationSettingsTemplate',

        resetCollection: function () {
            const me = this;

            // silently update all the checkbox rows with new settings
            const enabled = RivalIQ.state.user.get('emailSettings');
            me.collection.each(function (row) {
                const dashboardEmailTypeId = row.get('dashboardEmailTypeId');
                if (dashboardEmailTypeId) {
                    row.set({
                        enabled: enabled[dashboardEmailTypeId]
                    }, {
                        silent: true
                    });
                }
            });

            // render once
            me.render();
        },

        manageAllAlerts: function (e) {
            const me = this;
            const resetView = new views.EmailReset({
                model: RivalIQ.state.user
            });

            e.preventDefault();

            me.listenTo(resetView, 'reset:landscapes', me.resetCollection);
            return RivalIQ.execute('show:modal', resetView);
        },

        initialize: function () {

            const me = this;
            me.listenTo(RivalIQ.state.landscape, 'change:activeSources', me.render);
        }
    });

});
